import type { Catalog, CartItemBase } from 'core';

export enum PRODUCT_CARD_CONST {
  TEST_ID = 'product-card',
}

type Price = {
  discount: string;
  maxPrice: string;
  percent: string;
  price: string;
};

type ResellerPrice = {
  price: string;
  profit: string;
  maxPrice?: string;
  discountPercentage?: number;
  discount?: number;
};

type ConsumerPrice = {
  price: string;
  maxPrice: string;
  percent?: number;
  discount?: number;
};

export type ProductCardProps = Omit<
  Catalog['data'][number],
  'inventory' | 'slugName' | 'description' | 'url'
> & {
  isBuyIntention: boolean;
  onQuantityChange: (queryOptions: CartItemBase) => void;
  onAddProduct: (productCode: CartItemBase['productCode']) => void;
};
